import React, { ChangeEvent } from 'react';
import { FormField } from './FormField';

interface SelectOption {
    value: string | number;
    label: string;
}

interface SelectFieldProps {
    id: string;
    label: string;
    value: string | number;
    onChange: (value: string | number) => void;
    options: SelectOption[];
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    tooltip?: string;
    error?: string;
    className?: string;
}

export const SelectField: React.FC<SelectFieldProps> = ({
    id,
    label,
    value,
    onChange,
    options,
    required = false,
    disabled = false,
    placeholder,
    tooltip,
    error,
    className = ''
}) => {
    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value;
        // Try to convert to number if it's numeric, otherwise keep as string
        const finalValue = !isNaN(Number(newValue)) && newValue !== '' ? Number(newValue) : newValue;
        onChange(finalValue);
    };

    return (
        <FormField
            label={label}
            id={id}
            required={required}
            tooltip={tooltip}
            error={error}
        >
            <select
                id={id}
                value={value}
                onChange={handleChange}
                className={`form-select ${className}`}
                disabled={disabled}
                required={required}
            >
                {placeholder && (
                    <option value="">{placeholder}</option>
                )}
                {options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </FormField>
    );
};
